module.exports = __webpack_public_path__ + "static/media/search.ff0d7018.svg";